import React from 'react'

export default function Iframe(props) {
  return (
    <div className="iframe-container position-relative">
      <iframe style={{border: "1px solid rgba(0, 0, 0, 0.1)", left: '0'}} className="figma border-0 w-100 h-100 position-absolute" src={props.url} allowFullScreen></iframe>
    </div>
  )
}
